import React, { FC, ReactNode } from "react";
import { VODAdminSidebar } from "./components/Sidebar";
import AdminLayout from "./AdminLayout";


interface Props {
    heading: ReactNode;
    subHeading?: ReactNode;
    sidebar?: React.ReactNode
    children?: ReactNode;
}

export const VODAdminLayout: FC<Props> = ({
    heading,
    subHeading = (<></>),
    sidebar = <VODAdminSidebar />,
    children,
}) => {
    return (
        <AdminLayout heading={heading} subHeading={subHeading} sidebar={sidebar}>
        {children}
        </AdminLayout>
    );
};

export default VODAdminLayout;